/**
 * Pure auth/sync helpers (PLAN-Z M9): no I/O, directly unit-testable.
 */

export const SYNTHETIC_EMAIL_DOMAIN = 'users.dmat-prep.app'
export const USERNAME_PATTERN = /^[a-z0-9_-]{3,20}$/

/** Usernames are the identity and restricted to a URL/ssh-safe charset so the
 * synthetic email is always a valid address. */
export function usernameValid(username: string): boolean {
  return USERNAME_PATTERN.test(username)
}

/** Accounts created without an email get this synthetic address. It receives
 * no mail and is never shown (PLAN.md §5). */
export function syntheticEmail(username: string): string {
  return `${username}@${SYNTHETIC_EMAIL_DOMAIN}`
}

export function looksLikeEmail(input: string): boolean {
  return input.includes('@')
}

/**
 * Union merge by attempt id (PLAN.md §5): a retried or duplicated sync can
 * never double-count. On the (structurally impossible) id collision the
 * local copy wins; the result is sorted oldest first.
 */
export function mergeAttempts<T extends { id: string; answeredAt: string }>(
  local: T[],
  remote: T[],
): T[] {
  const byId = new Map<string, T>()
  for (const a of local) byId.set(a.id, a)
  for (const a of remote) {
    if (!byId.has(a.id)) byId.set(a.id, a)
  }
  return [...byId.values()].sort((a, b) => a.answeredAt.localeCompare(b.answeredAt))
}
